/* eslint-disable */
// Src: https://bulma.io/documentation/components/navbar/
const $ = require('jquery');

const helperToggleActive = function (el) {
	// Toggle the "is-active" class on both the selector and itself
	const selector = $(el).data('toggle-selector');
	const notSelf = $(el).data('toggle-not-self');
	if (!notSelf) {
		$(el).toggleClass('is-active');
	}
	$(selector).toggleClass('is-active');
};

const toggleActive = function () {
	// Check for click events on the "js-toggle-active" class
	$('.js-toggle-active').click(function () {
		// Toggle the "is-active" class on both the selector and itself
		helperToggleActive(this);
	});
};

module.exports = toggleActive;